import ClickableSVG from './ClickableSVG';

export default ClickableSVG;
